import React, { useState } from "react";
import Checkbox from "@mui/material/Checkbox";
import ModalProcessor from "../../Modal/RejectModal/ModalProcessor";
import "./freeFrom.scss";
import CloseIcon from "@mui/icons-material/Close";
import VisibilityIcon from "@mui/icons-material/Visibility";

const FreeFormRowRejectAndReviewNew = ({
  handleRowRejection,
  deleteRowRejection,
  role,
  isReadOnly,
  markAsResolveRejection,
  isDataRejectedByProcessor,
  parameterData,
  parameterIndex,
  isDataRejectedByValidator,
  isShowClearButton,
  heading,
  disableFooterBtns,
  icon,
}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [index
    // , setIndex
  ] = useState(null);

  const handleChange = (index) => {
    setModalOpen(true);
  };

  const handleClose = () => {
    setModalOpen(false);
  };

  const handleReject = (comment) => {
    handleRowRejection(parameterIndex, comment);
    setModalOpen(false);
  };

  const handleDeleteRejection = () => {
    deleteRowRejection(parameterIndex);
    setModalOpen(false);
  };

  const markAsResolve = () => {
    markAsResolveRejection(parameterIndex);
    setModalOpen(false);
  };

  // disable delete button(inside rejection model) untill rejected
  const disableDeleteRejection = () => {
    // if the cell is rejected then only enable delete button
    if (role === "preProcessor") {
      return parameterData?.processorRowRejection?.isRejected ? false : true;
    } else if (role === "processor") {
      return parameterData?.processorRowRejection?.isRejected ? false : true;
    } else if (role === "validator") {
      return parameterData?.validatorRowRejection?.isRejected ? false : true;
    }
  };

  const isChecked = () => {
    let checked = false;
    if (role === "preProcessor") {
      checked = parameterData?.processorRowRejection?.isRejected ? true : false;
    } else if (role === "validator") {
      checked = parameterData?.validatorRowRejection?.isRejected ? true : false;
    } else if (role === "processor") {
      checked = parameterData?.processorRowRejection?.isRejected ? true : false;
    }

    // 2nd check box in processor role after rejected by validator
    if (role === "processor" && isReadOnly) {
      // temp com because not know whee it used fix later
      checked = parameterData?.validatorRowRejection?.isRejected;
    }
    if (role === "preProcessor" && isReadOnly) {
      checked = parameterData?.processorRowRejection?.isRejected;
    }
    return checked;
  };

  const isDisabled = (index) => {
    if (role === "preProcessor" && isDataRejectedByProcessor) {
      // if row rejected by vali then enable only in pro role to view and resolve rejection did by vali in pro role
      return parameterData?.processorRowRejection?.isRejected ? false : true;
    } else if (role === "processor" && isDataRejectedByValidator) {
      // if row rejected by vali then enable only in pro role to view and resolve rejection did by vali in pro role
      return parameterData?.validatorRowRejection?.isRejected ? false : true;
    } else if (role === "validator") {
      if (parameterData && parameterData?.rowValidation?.isValidated) {
        return true;
      }
    } else return false;
  };

  const rejectionContent = () => {
    let remark = "";
    if (isDataRejectedByValidator) {
      remark = parameterData?.validatorRowRejection?.remark;
    } else {
      remark =
        role === "validator"
          ? parameterData?.validatorRowRejection?.remark
          : parameterData?.processorRowRejection?.remark;
    }
    return remark;
  };

  const onChangeCheckBox = () => {
    if (role === "preProcessor") {
      handleChange();
    }
    if (role === "processor") {
      if (!isReadOnly && !isChecked()) {
        handleChange();
      }

      if (isChecked() && !isReadOnly) {
        handleDeleteRejection();
      }

      if (isReadOnly && isDataRejectedByValidator) {
        handleChange();
      }
    }
    if (role === "validator") {
      if (!isReadOnly && !isChecked()) {
        handleChange();
      }
      if (isChecked() && !isReadOnly) {
        handleDeleteRejection();
      }
    }
  };

  return (
    <>
      {icon === "view" ? (
        <VisibilityIcon onClick={(e) => onChangeCheckBox()} />
      ) : (
        <div className="checkbox-wrap">
          <Checkbox
            className="rej-check"
            id="rejection"
            name="rejection"
            size="small"
            checked={isChecked()}
            onChange={(e) => onChangeCheckBox()}
            disabled={isDisabled(index)}
            checkedIcon={<CloseIcon className="check-icon" />}
          />
        </div>
      )}

      <ModalProcessor
        modalOpen={modalOpen}
        handleClose={handleClose}
        handleReject={handleReject}
        isShowClearButton={isShowClearButton}
        markAsResolve={markAsResolve}
        handleDeleteRejection={handleDeleteRejection}
        isReadOnly={isReadOnly}
        disableDeleteRejection={disableDeleteRejection()} // temp
        rejectionContent={rejectionContent}
        heading={heading}
        disableFooterBtns={disableFooterBtns}
      />
    </>
  );
};

FreeFormRowRejectAndReviewNew.defaultProps = {
  icon: "checkbox",
};

export default FreeFormRowRejectAndReviewNew;
